export const ProfileTypes = {
  doctor: 'DOCTOR',
  doctor_moons: 'DOCTOR_MOONS',
  superadmin: 'SUPER_ADMIN',
}

/**
 * Resolve the role that drives navigation.
 *
 * The login endpoint returns *every* role the user belongs to, in whatever
 * order Parse yields them, and staff belong to both ADMIN (referenced by the
 * Planning ACLs) and their own profile role. Taking `role[0]` blindly picked
 * ADMIN — a role no route declares — which left the user with no menu and no
 * reachable view.
 * @param {Object} user authenticated user
 * @returns {Object} role whose name the router knows how to dispatch
 */
export const resolveProfileRole = (user = {}) => {
  const { role = [], userType = '' } = user
  const profiles = Object.values(ProfileTypes)

  return role.find(item => item && item.name === userType)
    || role.find(item => item && profiles.includes(item.name))
    || role[0]
    || { name: userType }
}
